import React from "react";
import Banner from "../../components/Banner";
import { Sidebar } from "../../components/Sidebar";
import axios from "axios";
import Spinner from "../../components/Spinner";
import "../../css/Wireframe.css";

const API = localStorage.getItem("assethost");

// Flattened helper arrays
const ASSET_TYPE_OPTIONS = [
  { value: "", label: "Select" },
  { value: "MOBILE", label: "MOBILE" },
  { value: "ELECTRONICS", label: "ELECTRONICS" },
  { value: "ELECTRICAL", label: "ELECTRICAL" },
  { value: "MECHANICAL", label: "MECHANICAL" },
  { value: "FURNITURE", label: "FURNITURE" },
  { value: "VEHICLES", label: "VEHICLES" },
  { value: "ANIMALS", label: "ANIMALS" },
];

export default class CategorySettings extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      // List state
      categories: [],
      // Pagination
      page: 0,
      size: 10,
      totalPages: 1,
      // Editing state - flattened where possible
      editing: false,
      viewingSubcats: false,
      currentCategoryIndex: -1,
      categoryId: 0,
      categoryName: "",
      categoryActiveStatus: "YES",
      categorySubcategories: [], // Array of {name: "", assetType: "MOBILE", activeStatus: "YES"}
      // UI state
      loading: true,
      valid: true,
      msg: "",
      toastColor: "",
      errors: {},
    };
    this.handleChange = this.handleChange.bind(this);
    this.handleSelect = this.handleSelect.bind(this);
    this.handleSubcategoryChange = this.handleSubcategoryChange.bind(this);
    this.addSubcategory = this.addSubcategory.bind(this);
    this.removeSubcategory = this.removeSubcategory.bind(this);
    this.handleSave = this.handleSave.bind(this);
    this.handleEdit = this.handleEdit.bind(this);
    this.handleViewSubcats = this.handleViewSubcats.bind(this);
    this.handleBackToCategories = this.handleBackToCategories.bind(this);
    this.handleCancelEdit = this.handleCancelEdit.bind(this);
    this.validate = this.validate.bind(this);
    this.fetchCategories = this.fetchCategories.bind(this);
    this.fetchCategoryByIndex = this.fetchCategoryByIndex.bind(this);
  }

  componentDidMount() {
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        loading: false,
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
        window.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      return;
    }
    this.fetchCategories(0, 10, token);
  }

  fetchCategories(page, size, token) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    axios
      .get(API + "/settings/getallcategorys", {
        params: { page, size },
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        let categories = [];
        let totalPages = 1;
        if (Array.isArray(response.data)) {
          categories = response.data;
        } else if (
          response.data &&
          response.data.content &&
          Array.isArray(response.data.content)
        ) {
          categories = response.data.content;
          totalPages = response.data.totalPages || 1;
        } else {
          categories = [];
        }
        this.setState({
          categories,
          page,
          totalPages,
          loading: false,
        });
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          categories: [],
          totalPages: 1,
          loading: false,
          msg: error?.response?.data?.message || "Failed to load categories.",
          toastColor: "danger",
        });
      });
  }

  fetchCategoryByIndex(index) {
    this.setState({ loading: true, msg: "", toastColor: "" });
    const token = sessionStorage.getItem("token");
    axios
      .get(
        `${API}/settings/getcategorybyid/${
          this.state.categories && this.state.categories[index]?.id
        }`,
        {
          headers: { Authorization: `Bearer ${token}` },
        }
      )
      .then((response) => {
        if (response.data) {
          let categories = this.state.categories;
          categories[index] = response.data;
          const subcategories = response.data?.subcategorys || [];
          this.setState({
            categories,
            loading: false,
            categorySubcategories: subcategories.map((sub) => ({
              name: sub.name || "",
              assetType: sub.assetType || "MOBILE",
              activeStatus: sub.activeStatus || "YES",
            })),
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        this.setState({
          loading: false,
          msg:
            error?.response?.data?.message ||
            `Failed to load category ${
              this.categories && this.categories[index]?.id
            }.`,
          toastColor: "danger",
        });
      });
  }

  handleChange(e) {
    const { name, value } = e.target;
    this.setState({ [name]: value }, this.validate);
  }

  handleSelect(name, selectedOption) {
    let value = "";
    if (Array.isArray(selectedOption)) {
      value = selectedOption.map((option) => option.value);
    } else if (selectedOption) {
      value = selectedOption.value;
    }
    this.setState({ [name]: value }, this.validate);
  }

  handleSubcategoryChange(index, field, e) {
    const value = e.target.value;
    const newSubcategories = [...this.state.categorySubcategories];
    newSubcategories[index][field] = value;
    this.setState({ categorySubcategories: newSubcategories }, this.validate);
  }

  addSubcategory() {
    const newSubcat = { name: "", assetType: "", activeStatus: "YES" };
    this.setState(
      {
        categorySubcategories: [...this.state.categorySubcategories, newSubcat],
      },
      this.validate
    );
  }

  removeSubcategory(index) {
    const newSubcategories = this.state.categorySubcategories.filter(
      (_, i) => i !== index
    );
    this.setState({ categorySubcategories: newSubcategories }, this.validate);
  }

  validate() {
    const s = this.state;
    let errors = {};
    let valid = true;

    if (this.state.editing) {
      // Category validation
      if (!s.categoryName || !s.categoryName.trim()) {
        errors.categoryName = "Category name is required";
        valid = false;
      }
      if (!s.categoryActiveStatus || !s.categoryActiveStatus.trim()) {
        errors.categoryActiveStatus = "Active status is required";
        valid = false;
      }
      // Subcategory validation
      errors.categorySubcategories = [];
      s.categorySubcategories.forEach((sub, index) => {
        const subErrors = {};
        if (!sub.name || !sub.name.trim()) {
          subErrors.name = "Subcategory name is required";
          valid = false;
        }
        if (!sub.assetType || !sub.assetType.trim()) {
          subErrors.assetType = "Asset type is required";
          valid = false;
        }
        if (!sub.activeStatus || !sub.activeStatus.trim()) {
          subErrors.activeStatus = "Active status is required";
          valid = false;
        }
        if (Object.keys(subErrors).length > 0) {
          errors.categorySubcategories[index] = subErrors;
        }
      });
      if (s.categorySubcategories.length === 0) {
        errors.categorySubcategoriesEmpty =
          "At least one subcategory is required";
        valid = false;
      }
    }
    this.setState({ errors, valid });
    return valid;
  }

  handleSave(e) {
    if (e) e.preventDefault();
    const token = sessionStorage.getItem("token");
    if (!token) {
      this.setState({
        msg: "No user session/token. Please login.",
        toastColor: "danger",
      });
      sessionStorage.clear();
        window.href = `/?redirectUrl=${
          window.location.pathname + window.location.search
        }`;
      return;
    }
    if (!this.validate()) {
      this.setState({
        msg: "Fix the errors above and try again.",
        toastColor: "danger",
      });
      return;
    }
    this.setState({ loading: true, msg: "", toastColor: "" });

    // Build category object
    const request = {
      id: this.state.categoryId,
      name: this.state.categoryName,
      activeStatus: this.state.categoryActiveStatus,
      subcategorys: this.state.categorySubcategories,
    };

    const self = this;
    axios
      .post(API + "/settings/categorysave", request, {
        headers: { Authorization: `Bearer ${token}` },
      })
      .then((response) => {
        if (response.data.success) {
          self.setState({
            msg: response.data.message || "Category saved successfully!",
            toastColor: "success",
            loading: false,
          });
          // Reset form
          self.setState({
            categoryId: 0,
            categoryName: "",
            categoryActiveStatus: "YES",
            categorySubcategories: [],
            editing: false,
            errors: {},
          });
          // Refetch data
          self.fetchCategories(self.state.page, self.state.size, token);
        } else {
          self.setState({
            msg: response.data.message || "Failed to save category.",
            toastColor: "danger",
            loading: false,
          });
        }
      })
      .catch((error) => {
        if (Number(error.status) === 403) {
          sessionStorage.clear();
          window.href = `/?redirectUrl=${
            window.location.pathname + window.location.search
          }`;
        }
        self.setState({
          msg:
            error?.response?.data?.message ||
            "Failed to save category. Please try again.",
          toastColor: "danger",
          loading: false,
        });
      });
  }

  handleEdit(category) {
    const index = this.state.categories.findIndex((c) => (c.id === category.id));
    const subcats = category.subcategorys || [];
    this.setState(
      {
        editing: true,
        viewingSubcats: false,
        currentCategoryIndex: -1,
        categoryId: category.id || 0,
        categoryName: category.name || "",
        categoryActiveStatus: category.activeStatus || "YES",
        categorySubcategories: subcats.map((sub) => ({
          name: sub.name || "",
          assetType: sub.assetType || "MOBILE",
          activeStatus: sub.activeStatus || "YES",
        })),
      },
      this.validate
    );
    if (index) {
      this.fetchCategoryByIndex(index);
    }
  }

  handleViewSubcats(index) {
    if (
      !this.state.categories ||
      !this.state.categories[index]?.subcategorys?.length
    ) {
      this.fetchCategoryByIndex(index);
    }
    this.setState({
      viewingSubcats: true,
      currentCategoryIndex: index,
      editing: false,
    });
  }

  handleBackToCategories() {
    this.setState({
      viewingSubcats: false,
      currentCategoryIndex: -1,
    });
  }

  handleCancelEdit() {
    this.setState({
      editing: false,
      viewingSubcats: false,
      currentCategoryIndex: -1,
      categoryId: 0,
      categoryName: "",
      categoryActiveStatus: "YES",
      categorySubcategories: [],
      errors: {},
    });
  }

  handlePreviousPage() {
    if (this.state.page > 0) {
      const token = sessionStorage.getItem("token");
      this.fetchCategories(this.state.page - 1, this.state.size, token);
    }
  }

  handleNextPage() {
    if (this.state.page + 1 < this.state.totalPages) {
      const token = sessionStorage.getItem("token");
      this.fetchCategories(this.state.page + 1, this.state.size, token);
    }
  }

  render() {
    const s = this.state;
    let divMsg = null;
    if (s.msg) {
      divMsg = (
        <div
          className={
            s.toastColor === "success"
              ? "alert alert-success mx-7"
              : "alert alert-danger mx-7"
          }
        >
          {s.msg}
        </div>
      );
    }

    if (s.loading) {
      return <Spinner className="" />;
    }

    return (
      <div className="min-vh-100 d-flex justify-content-between bg-white">
        <Sidebar />
        <div className="min-vh-100 flex-grow-1 d-flex flex-column">
          <Banner title="Category Settings" />
          {divMsg}
          <div className="d-flex flex-column flex-grow-1 px-5 h-60">
            {s.editing ? (
              // Edit/Add Category Form
              <form
                className="d-flex flex-column align-items-center w-100 mt-2 pt-3 pb-2 h-100 overflow-auto"
                autoComplete="off"
                onSubmit={this.handleSave}
              >
                <div className="w-100" style={{maxWidth: 62 + 'rem'}}>
                  <div className="row g-3">
                    <div className="input-group">
                      <label className="input-group-text">Category Name</label>
                      <input
                        name="categoryName"
                        className={`form-control ${
                          s.errors.categoryName ? " !border-red-500" : ""
                        }`}
                        value={s.categoryName}
                        onChange={this.handleChange}
                        required
                        autoFocus
                      />
                      {s.errors.categoryName && (
                        <span className="input-group-error">
                          {s.errors.categoryName}
                        </span>
                      )}
                    </div>
                    <div className="input-group">
                      <label className="input-group-text">Active Status</label>
                      <select
                        name="categoryActiveStatus"
                        className={`form-control ${
                          s.errors.categoryActiveStatus
                            ? " !border-red-500"
                            : ""
                        }`}
                        value={s.categoryActiveStatus}
                        onChange={this.handleChange}
                        required
                      >
                        <option value="YES">Yes</option>
                        <option value="NO">No</option>
                      </select>
                      {s.errors.categoryActiveStatus && (
                        <span className="input-group-error">
                          {s.errors.categoryActiveStatus}
                        </span>
                      )}
                    </div>
                  </div>
                  <div className="d-flex justify-content-start gap-3 mt-4">
                    <button
                      type="button"
                      className="btn btn-primary"
                      onClick={this.addSubcategory}
                    >
                      Add Subcategory
                    </button>
                  </div>
                  {s.categorySubcategories.length > 0 && (
                    <div className="overflow-x-auto mt-4 border h-fit">
                      <table className="min-w-full divide-y divide-gray-200 table table-striped table-hover rounded-md">
                        <thead className="table-primary">
                          <tr>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Name
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Asset Type
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Active Status
                            </th>
                            <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                              Actions
                            </th>
                          </tr>
                        </thead>
                        <tbody className="bg-white divide-y divide-gray-200">
                          {s.categorySubcategories.map((sub, index) => (
                            <tr key={`add-subcat-${index}`}>
                              <td className="px-6 py-4">
                                <div className="input-group">
                                  <input
                                    className={`form-control ${
                                      s.errors.categorySubcategories &&
                                      s.errors.categorySubcategories[index] &&
                                      s.errors.categorySubcategories[index].name
                                        ? " !border-red-500"
                                        : ""
                                    }`}
                                    value={sub.name}
                                    onChange={(e) =>
                                      this.handleSubcategoryChange(
                                        index,
                                        "name",
                                        e
                                      )
                                    }
                                    required
                                  />
                                  {s.errors.categorySubcategories &&
                                    s.errors.categorySubcategories[index] &&
                                    s.errors.categorySubcategories[index]
                                      .name && (
                                      <span className="input-group-error">
                                        {
                                          s.errors.categorySubcategories[index]
                                            .name
                                        }
                                      </span>
                                    )}
                                </div>
                              </td>
                              <td className="px-6 py-4">
                                <div className="input-group">
                                  <select
                                    className={`form-control ${
                                      s.errors.categorySubcategories &&
                                      s.errors.categorySubcategories[index] &&
                                      s.errors.categorySubcategories[index]
                                        .assetType
                                        ? " !border-red-500"
                                        : ""
                                    }`}
                                    value={sub.assetType}
                                    onChange={(e) =>
                                      this.handleSubcategoryChange(
                                        index,
                                        "assetType",
                                        e
                                      )
                                    }
                                    required
                                  >
                                    {ASSET_TYPE_OPTIONS.map((option) => (
                                      <option
                                        key={`asset-type-${option.value}`}
                                        value={option.value}
                                      >
                                        {option.label}
                                      </option>
                                    ))}
                                  </select>
                                  {s.errors.categorySubcategories &&
                                    s.errors.categorySubcategories[index] &&
                                    s.errors.categorySubcategories[index]
                                      .assetType && (
                                      <span className="input-group-error">
                                        {
                                          s.errors.categorySubcategories[index]
                                            .assetType
                                        }
                                      </span>
                                    )}
                                </div>
                              </td>
                              <td className="px-6 py-4">
                                <div className="input-group">
                                  <select
                                    className={`form-control ${
                                      s.errors.categorySubcategories &&
                                      s.errors.categorySubcategories[index] &&
                                      s.errors.categorySubcategories[index]
                                        .activeStatus
                                        ? " !border-red-500"
                                        : ""
                                    }`}
                                    value={sub.activeStatus}
                                    onChange={(e) =>
                                      this.handleSubcategoryChange(
                                        index,
                                        "activeStatus",
                                        e
                                      )
                                    }
                                    required
                                  >
                                    <option value="YES">Yes</option>
                                    <option value="NO">No</option>
                                  </select>
                                  {s.errors.categorySubcategories &&
                                    s.errors.categorySubcategories[index] &&
                                    s.errors.categorySubcategories[index]
                                      .activeStatus && (
                                      <span className="input-group-error">
                                        {
                                          s.errors.categorySubcategories[index]
                                            .activeStatus
                                        }
                                      </span>
                                    )}
                                </div>
                              </td>
                              <td className="px-6 py-4">
                                <button
                                  type="button"
                                  className="btn btn-danger"
                                  onClick={() => this.removeSubcategory(index)}
                                >
                                  Remove
                                </button>
                              </td>
                            </tr>
                          ))}
                        </tbody>
                      </table>
                    </div>
                  )}
                  {s.errors.categorySubcategoriesEmpty && (
                    <span className="input-group-error">
                      {s.errors.categorySubcategoriesEmpty}
                    </span>
                  )}
                </div>
                <div className="d-flex justify-content-center gap-3 mt-4">
                  {s.valid && s.categorySubcategories.length > 0 ? (
                    <button type="submit" className="btn btn-primary">
                      Save
                    </button>
                  ) : null}
                  <button
                    type="button"
                    className="btn btn-primary"
                    onClick={this.handleCancelEdit}
                  >
                    Cancel
                  </button>
                </div>
              </form>
            ) : s.viewingSubcats ? (
              // View Subcategories
              <div className="h-full w-full">
                <div className="flex gap-2 mb-2 items-baseline justify-between">
                  <h3 className="font-bold">
                    Configured Subcategories for Category '
                    {s.categories[s.currentCategoryIndex].name}'
                  </h3>
                  <button
                    className="btn btn-primary"
                    onClick={this.handleBackToCategories}
                  >
                    Back
                  </button>
                </div>
                {s.categories[s.currentCategoryIndex].subcategorys?.length ===
                0 ? (
                  <div className="text-muted">No subcategories found.</div>
                ) : (
                  <div className="overflow-x-auto w-full border h-[90%] relative overflow-y-auto">
                    <table className="min-w-full divide-y divide-gray-200 table table-striped table-hover rounded-md">
                      <thead className="bg-gray-50 sticky top-0">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            ID
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Name
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Asset Type
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Active Status
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {s.categories[s.currentCategoryIndex].subcategorys?.map(
                          (sub, index) => (
                            <tr
                              key={`subcat-view-${index}`}
                              className="hover:bg-gray-50"
                            >
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {sub.id}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {sub.name}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {sub.assetType}
                              </td>
                              <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                                {sub.activeStatus}
                              </td>
                            </tr>
                          )
                        )}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            ) : (
              // Categories List
              <div className="h-full w-full">
                <div className="flex gap-2 mb-2 items-baseline justify-between">
                  <h3 className="font-bold">Configured Categories</h3>
                  <button
                    className="hover:font-bold flex gap-1 group"
                    onClick={() => this.handleEdit({})}
                  >
                    <i
                      className="bi bi-plus-circle group-hover:scale-105"
                      style={{ color: "black" }}
                    ></i>
                    Add
                  </button>
                </div>
                {s.categories.length === 0 ? (
                  <div className="text-muted">No categories found.</div>
                ) : (
                  <div className="overflow-x-auto w-full border h-[93%] relative overflow-y-auto">
                    <table className="min-w-full divide-y divide-gray-200 table table-striped table-hover rounded-md">
                      <thead className="bg-gray-50 sticky top-0">
                        <tr>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            ID
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Name
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Active Status
                          </th>
                          <th className="px-6 py-3 text-left text-xs font-medium text-gray-500 uppercase tracking-wider">
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody className="bg-white divide-y divide-gray-200">
                        {s.categories.map((category, index) => (
                          <tr
                            key={`category-row-${category.id}`}
                            className="hover:bg-gray-50"
                          >
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {category.id}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {category.name}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm text-gray-900">
                              {category.activeStatus}
                            </td>
                            <td className="px-6 py-4 whitespace-nowrap text-sm font-medium">
                              <button
                                className="btn btn-primary mr-2"
                                onClick={() => this.handleViewSubcats(index)}
                              >
                                View Subcategories
                              </button>
                              <button
                                className="btn btn-primary"
                                onClick={() => {
                                  this.fetchCategoryByIndex(index);
                                  this.handleEdit(category);
                                }}
                              >
                                Edit
                              </button>
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
                {s.totalPages > 1 && (
                  <div className="d-flex justify-content-center align-items-center gap-2 mt-4">
                    <button
                      className="btn btn-outline"
                      disabled={s.page === 0}
                      onClick={this.handlePreviousPage}
                    >
                      Previous
                    </button>
                    <span>
                      Page {s.page + 1} of {s.totalPages}
                    </span>
                    <button
                      className="btn btn-outline"
                      disabled={s.page + 1 >= s.totalPages}
                      onClick={this.handleNextPage}
                    >
                      Next
                    </button>
                  </div>
                )}
              </div>
            )}
          </div>
          
        </div>
      </div>
    );
  }
}
